<template>
  <div>
    <el-table
      :data="tableList"
      style="width: 100%"
      :max-height="height"
      @expand-change="expand"
      ref="table"
    >
      <el-table-column type="expand" class="rowTable">
        <template slot-scope="{ row }">
          <!-- <div class="list">
            <div class="list_hearder">
              <div>ID</div>
              <div>雨伞归还数量</div>
              <div>异常记录</div>
              <div>归还时间</div>
              <div>操作</div>
            </div>
            <div
              class="list_body"
              v-for="(i, index) in row.children"
              :key="index"
            >
              <div>{{ i.buRecordId }}</div>
              <div>{{ i.num }}</div>
              <div>{{ i.remark }}</div>
              <div>{{ i.backTimeStr }}</div>
              <div>
                <el-button
                  @click="submit(i)"
                  type="text"
                  size="small"
                  style="color: #4fa27d; font-size: 16px"
                  >确认</el-button
                >
              </div>
            </div>
          </div> -->
          <el-table
            :data="row.children"
            style="width: 100%"
            class="rowTable"
            :border="false"
            ref="rowTable"
          >
            <el-table-column prop="id" label="ID" align="center" width="180">
            </el-table-column>
            <el-table-column prop="num" label="雨伞归还数量" align="center">
            </el-table-column>
            <el-table-column prop="remark" label="异常记录" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.damageNum || scope.row.loseNum">
                  丢失:{{ scope.row.loseNum }}&emsp;损坏:{{
                    scope.row.damageNum
                  }}
                </div>
                <div v-else>--</div>
              </template>
            </el-table-column>
            <el-table-column prop="backTimeStr" label="归还时间" align="center">
            </el-table-column>
            <el-table-column prop="desc" label="确认" align="center">
              <template slot-scope="scope">
                <el-popconfirm title="确定要通过吗？" @confirm="Ok(scope.row)">
                  <el-button
                    type="text"
                    size="small"
                    style="margin-right: 20px; color: #4fa27d; font-size: 16px"
                    slot="reference"
                    class="add"
                    >确认</el-button
                  >
                </el-popconfirm>
                <el-button
                  @click="result(scope.row)"
                  type="text"
                  size="small"
                  style="color: #4fa27d; font-size: 16px"
                  >拒绝</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column label="编号" prop="id" width="90" align="center">
      </el-table-column>
      <el-table-column
        label="借伞人"
        prop="empName"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="所属部门" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="department">{{ scope.row.department }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="联系电话"
        prop="phone"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        label="所属地点"
        prop="place"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        label="借出时间"
        prop="buTime"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        label="借出数量"
        prop="num"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        label="已归还数量"
        prop="returnNum"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        label="剩余未归数量"
        prop=""
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.num - scope.row.returnNum - scope.row.errorNum }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="归还状态"
        prop="state"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div style="display: flex;justify-content: center;">
            <div
              class="tag tag1"
              style="font-size: 12px"
              v-if="scope.row.state == 1"
            >
              未归还
            </div>
            <div
              class="tag tag2"
              style="font-size: 12px"
              v-if="scope.row.state == 2"
            >
              已归还
            </div>
            <div
              class="tag tag3"
              style="font-size: 12px"
              v-if="scope.row.state == 3"
            >
              异常
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <MyDialog :visible.sync="uploadDialog" type="1" :rowList="rowList" />
    <el-dialog :visible.sync="dialogVisibleApply" title="驳回" width="30%">
      <div class="text" style="margin-bottom: 15px; font-size: 16px">
        请输入驳回理由
      </div>
      <el-input
        type="textarea"
        :rows="4"
        placeholder="请输入内容"
        v-model="auditRemark"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button
          style="margin-right: 20px"
          @click="dialogVisibleApply = false"
          >取消</el-button
        >
        <el-button type="primary" @click="No">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MyDialog from "./borrowAndReturnDialog.vue";
import apis from "@/apis/borrowingAnUmbrella";
import { getToken } from "@/utils/cookie";
export default {
  name: "borrowAndReturnTableOne",
  components: {
    MyDialog,
  },
  props: ["tableListOne", "page"],
  computed: {
    indexMethod() {
      return (index) => (this.page.page - 1) * this.page.pageSize + index + 1;
    },
  },
  data() {
    return {
      // tableData: [
      //   {
      //     id: "12987122",
      //     name: "好滋好味鸡蛋仔",
      //     category: "江浙小吃、小吃零食",
      //     desc: "荷兰优质淡奶，奶香浓而不腻",
      //     address: "上海市普陀区真北路",
      //     shop: "王小虎夫妻店",
      //     shopId: "10333",
      //     children: [
      //       {
      //         id: "129871221",
      //         name: "好滋好味鸡蛋仔",
      //         category: "江浙小吃、小吃零食",
      //         desc: "荷兰优质淡奶，奶香浓而不腻",
      //         address: "上海市普陀区真北路",
      //         shop: "王小虎夫妻店",
      //         shopId: "10333",
      //       },
      //       {
      //         id: "129871223",
      //         name: "好滋好味鸡蛋仔",
      //         category: "江浙小吃、小吃零食",
      //         desc: "荷兰优质淡奶，奶香浓而不腻",
      //         address: "上海市普陀区真北路",
      //         shop: "王小虎夫妻店",
      //         shopId: "10333",
      //       },
      //     ],
      //   },
      //   {
      //     id: "12987123",
      //     name: "好滋好味鸡蛋仔",
      //     category: "江浙小吃、小吃零食",
      //     desc: "荷兰优质淡奶，奶香浓而不腻",
      //     address: "上海市普陀区真北路",
      //     shop: "王小虎夫妻店",
      //     shopId: "10333",
      //   },
      //   {
      //     id: "12987125",
      //     name: "好滋好味鸡蛋仔",
      //     category: "江浙小吃、小吃零食",
      //     desc: "荷兰优质淡奶，奶香浓而不腻",
      //     address: "上海市普陀区真北路",
      //     shop: "王小虎夫妻店",
      //     shopId: "10333",
      //   },
      //   {
      //     id: "12987126",
      //     name: "好滋好味鸡蛋仔",
      //     category: "江浙小吃、小吃零食",
      //     desc: "荷兰优质淡奶，奶香浓而不腻",
      //     address: "上海市普陀区真北路",
      //     shop: "王小虎夫妻店",
      //     shopId: "10333",
      //   },
      // ],
      tableList: [],
      height: window.innerHeight - 500,
      uploadDialog: false,
      dialogVisibleApply: false,
      rowList: {},
      auditRemark: "",
      rowId: "",
      // rowTableLoading: false,
    };
  },
  watch: {
    tableListOne(val) {
      this.tableList = val;
    },
  },
  mounted() {},
  methods: {
    //确认归还
    Ok(row) {
      const params = {
        id: row.id,
        state: 2,
        empNo: getToken(),
      };
      apis.confirmReturn(params).then(() => {
        this.$message({
          message: "确认成功",
          type: "success",
        });
        this.$emit("changeSubmit");
      });
    },
    //拒绝归还
    result(row) {
      this.rowId = row.id;
      this.dialogVisibleApply = true;
    },
    //驳回
    No() {
      if (!this.auditRemark) return this.$message.error("请输入驳回理由");
      const params = {
        id: this.rowId,
        state: 3,
        empNo: getToken(),
        reason: this.auditRemark,
      };
      apis.confirmReturn(params).then(() => {
        this.$message({
          message: "驳回成功",
          type: "success",
        });
        this.dialogVisibleApply = false;
        this.auditRemark = "";
        this.$emit("changeSubmit");
      });
    },
    // 展开行
    expand(row, expandedRows) {
      this.rowList = row;
      const params = {
        buRecordId: row.id,
        state: 1,
      };
      if (expandedRows.length > 0) {
        apis.returnList(params).then((res) => {
          // 遍历当前页面表
          this.tableList.forEach((temp, index) => {
            // 找到当前点击的行，把动态获取到的数据赋值进去
            if (temp.id === row.id) {
              this.tableList[index].children = res.data;
            }
          });
        });
      }
    },
    submit() {
      this.uploadDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.list_hearder {
  background: #fafafa;
  height: 100px;
  display: flex;
  align-items: center;
  div {
    width: 25%;
    text-align: center;
  }
}
.list_body {
  width: 100%;
  display: flex;
  align-items: center;
  height: 120px;
  div {
    width: 25%;
    text-align: center;
  }
}
::v-deep {
  .rowTable {
    thead {
      tr {
        th {
          background: #fafafa !important;
          height: 100px !important;
          border: none !important;
        }
      }
    }
    tbody {
      tr {
        td {
          background: #fafafa !important;
          height: 100px !important;
          border: none !important;
          z-index: 999;
        }
      }
    }
  }
}
</style>
